<mat-form-field class="status">
  <mat-label>{{ "Status"|translate }}</mat-label>
  <mat-select [formControl]="skjema().controls.status"
              [compareWith]="erValgt"
              panelClass="velg-oppgavestatus--alternativer"
              data-testid="oppgave-status-felt">
    <mat-select-trigger>
      {{statuserNavn.get(skjema().value.status)}}
    </mat-select-trigger>
    @for (status of statuser; track status) {
      <mat-option [value]="status">
        {{ statuserNavn.get(status) }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@if (skjema().value.status == utfoertEnumVerdi) {
  @if (autolagre()) {
    <span class="utført-dato">
      <!--{{ skjema().value.utfoertDato|zoneddatetime_relativ|async }}-->
    </span>
  } @else {
    <mat-form-field class="utført-dato" >
      <mat-label>{{ "Utført-dato"|translate }}</mat-label>
      <input matInput [formControl]="skjema().controls.utfoertDato" [matDatepicker]="utfoertDatoVelger" data-testid="oppgave-utførtdato-felt">
      <mat-datepicker-toggle matPrefix [for]="utfoertDatoVelger"/>
      <mat-datepicker #utfoertDatoVelger/>
      @if (skjema().controls.utfoertDato.hasError('matDatepickerParse')) {
        <mat-error
                data-testid="matDatepickerParse">{{ skjema().controls.utfoertDato.errors | standardvalideringsfeil:'matDatepickerParse' }}
        </mat-error>
      }
    </mat-form-field>
  }
}
